<main role="main">
    <div class="body-wrapper">
        <opt-sub-header></opt-sub-header>
        <app-search ></app-search>
    </div>
</main>

